import React from "react";
import { getReasonablePaddings, CssContentBlock, CSSsection, HH } from '../uikit-b2c/uikit-b2c';
import styled, { css, ThemeProvider } from "styled-components";
import Colorer from "color";

export const PSsection = ({
  order,
  label,
  section,
  // handle=()=>void(0),
  handle,
  theme = {},
  active = true,
  beforeLabel,
  children,
}) => {
  return (
    <PsBlock
      beforeLabel={active ? beforeLabel : null}
      order={order}
      handle={handle}
      style={{
        width: "100%",
        position: "relative",
        // margin: `${theme["paddings"] * 4}px 0px`,
        padding: active
          ? `${getReasonablePaddings(theme["paddings"]) +
              16}px 0px ${getReasonablePaddings(theme["paddings"]) + 16}px `
          : // : `${theme["paddings"] * 2}px 0px`
            `0px 0px`,
      }}
      theme={theme}
      label={active ? label : null}
      appearance="flatten"
      // appearance={active ? 'transparent' : 'transparent'}
      active={active}
      section={section}
    >
      {children}
    </PsBlock>
  );
};



export const PsBlock = ({
  order,
  children,
  appearance,
  beforeLabel,
  indentation = "md",
  theme,
  label,
  section,
  handle,
  active,
  style,
}) => {
  return (
    <CssContentBlock
      border={true}
      label={label}
      indentation={indentation}
      appearance="flatten"
      theme={theme}
      style={{
        transition: 'all 250ms ease-in-out',
        zIndex: active ? 10 : 1,
        // opacity: active ? 1 : 0.8,
        padding: 0,
        marginBottom: active ? `${getReasonablePaddings(theme["paddings"] * theme["cardContrast"] / 4)}px` : 0,
        marginTop: active ? `${getReasonablePaddings(theme["paddings"] * theme["cardContrast"] / 10, 4, 'xs')}px` : 0,
        ...style,
      }}
    >
      {handle && <CSSsection active={active} onClick={() => handle(section)} />}

      {!!beforeLabel && beforeLabel}

      {!!label && (
        <HH paddings={true} tag={"h2"}>
          {label}
        </HH>
      )}

      <div className="__uikitb2c_contentblock_inner">{children}</div>

      {active && (
        <PSsectionBack order={order} active={true} theme={theme}
        style={{
          borderRadius: `${theme["borderRadius"]}px`
        }}
        >
          {/* {!active && <Bg absolute={true} effect={true}/>} */}
        </PSsectionBack>
      )}
      {/* {!active &&<PSsectionBack order={order} active={false} theme={theme}> */}
        {/* {!active && <Bg absolute={true} effect={true}/>} */}
      {/* </PSsectionBack>} */}

      {/* {appearance === 'bg' && <Bg absolute={true}/>} */}
      {/* {appearance === 'bg-blurred' && <Bg absolute={true} effect={true}/>} */}
    </CssContentBlock>
  );
};



export const PSsectionBack = styled.div`
  overflow: hidden;
  position: absolute;
  /* top: -24px;
  right: -24px;
  bottom: -24px;
  left: -24px; */


  /* top: ${(props) => `-${props.theme["paddings"] * 2}px`};
  bottom:  ${(props) => `-${props.theme["paddings"] * 2}px`}; */
  top: 0px;
  bottom:  0px;
  right: 0px;
  left: 0px;
  transition: all 250ms ease-in-out;
  /* opacity: 0; */
  background: ${(props) => props.theme["colorBg"]};
  z-index: 0;

  ${({ order }) =>
    order === "first" &&
    css`
      border-top-right-radius: ${(props) =>
        `${props.theme["borderRadius"] * 0.8}px`};
      border-top-left-radius: ${(props) =>
        `${props.theme["borderRadius"] * 0.8}px`};
    `}
  ${({ order }) =>
    order === "last" &&
    css`
      border-bottom-right-radius: ${(props) =>
        `${props.theme["borderRadius"] * 0.8}px`};
      border-bottom-left-radius: ${(props) =>
        `${props.theme["borderRadius"] * 0.8}px`};
    `}
  ${({ active }) =>
    active &&
    css`
      border-radius: ${(props) => `${props.theme["borderRadius"]}px`};
      /* pointer-events: none; */
      z-index: -1;
      box-shadow: ${({ theme }) => `0px 8px ${20 * theme["cardContrast"]}px -16px
          ${Colorer(theme["colorText"])
            .darken(2)
            .alpha(1 / (theme["cardContrast"] / theme["paddings"]))
            .string()}`};
      right: ${({theme}) => `-${getReasonablePaddings(theme["paddings"] * theme["cardContrast"], 1, 'xlg') + theme["cardContrast"] + 16}px`};
      left: ${({theme}) => `-${getReasonablePaddings(theme["paddings"] * theme["cardContrast"], 1, 'xlg')+ theme["cardContrast"] + 16}px`};
      top: ${({theme}) => `-${getReasonablePaddings(theme["paddings"] * theme["cardContrast"], 1, 'xlg') + 16, 2}px`};
      bottom: ${({theme}) => `-${getReasonablePaddings(theme["paddings"] * theme["cardContrast"]) + 16, .2}px`};
    `}
  ${({ active }) =>
    !active &&
    css`
      z-index: -2;
      /* opacity: 0.1; */
      right: ${(props) => `-${props.theme["paddings"] + 16}px`};
      left: ${(props) => `-${props.theme["paddings"] + 16}px`};
      bottom: ${(props) => `-${props.theme["paddings"] * props.theme["cardContrast"] / 3}px`};
      background: ${({ active, theme }) =>
        active
          ? Colorer(theme.colorBg)
              .darken(0)
              .string()
          : Colorer(theme.colorBg)
              .darken(0.2)
              .string()};
    `}

  /* box-shadow: 0px 8px 20px -16px rgba(0,0,0,0.8); */

`;
